<template>
  <nav v-if="totalPages > 1">
    <ul class="pagination justify-content-end">
      <li class="page-item" :class="{ disabled: currentPage <= 1 }">
        <a class="page-link" @click="firstPage">Primeira</a>
      </li>
      <li v-if="currentPage > 1" class="page-item">
        <a @click="prevPage" class="page-link">{{ currentPage - 1 }}</a>
      </li>
      <li class="page-item active">
        <a class="page-link">{{ currentPage }}</a>
      </li>
      <li v-if="totalPages > currentPage" class="page-item">
        <a @click="nextPage" class="page-link">
          {{
          currentPage + 1
          }}
        </a>
      </li>
      <li class="page-item" :class="{ disabled: currentPage >= totalPages }">
        <a class="page-link" @click="lastPage">Última</a>
      </li>
    </ul>
  </nav>
</template>

<script>
export default {
  name: "pagination",
  props: {
    totalPages: Number,
    currentPage: Number
  },
  methods: {
    prevPage() {
      this.$emit("update", { currentPage: this.currentPage - 1 });
    },
    nextPage() {
      this.$emit("update", { currentPage: this.currentPage + 1 });
    },
    firstPage() {
      this.$emit("update", { currentPage: 1 });
    },
    lastPage() {
      this.$emit("update", { currentPage: this.totalPages });
    }
  }
};
</script>

<style lang="scss" scoped>
.page-item.active .page-link {
  background: #9dcf6b;
  color: #fff;
  border-color: #9dcf6b;
}
.page-link {
  color: #494949;
  
  &:hover {
    color: #9dcf6b;
  }
}
a:hover {
  cursor: pointer;
}
</style>
